import { Box, Button, Card, ImageList, ImageListItem, Paper, Typography } from "@mui/material";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { faker } from '@faker-js/faker';

const itemData = Array(30).fill(null).map((_, index) => {
  return {
    img: `https://picsum.photos/seed/${index + 1}/300/300`,
    title: `${faker.commerce.title()} Course`,
    user: `@${faker.person.firstName()}${index}`,
  };
});

export function ProductListing() {
  const navigate = useNavigate();
  return (
  <ImageList sx={{ width: '100%', height: '100%' }} cols={5} >
    {itemData.map((item, index) => (
      <ImageListItem key={index}>
        <img
          srcSet={`${item.img}`}
          src={`${item.img}`}
          alt={item.title}
          loading="lazy"
        />
        <Box sx={{ position: 'absolute', bottom: 10, left: 0, right: 0 }}>
          <Typography>
            {item.title}
          </Typography>
          <Button
            sx={{ marginRight: 2, marginTop: 2}}
            variant="contained"
            onClick={() => navigate(`/product/${index}`)}>
            Details
          </Button>
          {/* <Button
            color="success"
            variant="contained"
            onClick={() => navigate(`/subscribe/${index}`)}>
            Subscribe
          </Button> */}
        </Box>

      </ImageListItem>
    ))}
  </ImageList>
  );
}


export default ProductListing;